import { ref } from "vue";
import { defineStore, storeToRefs } from "pinia";
import CryptoJS from "crypto-js";
import axios from "axios";

import { useAuthenticationStore } from "@/stores/authentication";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "logSources";

export const useLogSourcesStore = defineStore(
  key,
  () => {
    // state

    const logSources = ref(null);

    // actions

    const initialize = async (organisationId, pageSize = 0, page = 0) => {
      const authenticationStore = useAuthenticationStore();
      const { authentication } = storeToRefs(authenticationStore);

      const headers = {
        Authorization: `Bearer ${authentication.value}`,
      };

      let url = `log-sources/${organisationId}`;

      if (pageSize > 0 && page > 0) {
        url += `?pageSize=${pageSize}&page=${page}`;
      }

      await axios
        .get(url, { headers })
        .then(({ data }) => {
          logSources.value = [];
          if (data.success && data.log_sources !== null) {
            logSources.value = data.log_sources;
          }
        })
        .catch(() => {
          logSources.value = null;
        });
    };

    const remove = (logSourceId) => {
      logSources.value = logSources.value.filter(
        (logSource) => logSource.id !== logSourceId,
      );
    };

    const set = (value) => {
      logSources.value = value;
    };

    const unset = () => {
      logSources.value = null;
    };

    return {
      logSources,
      initialize,
      remove,
      set,
      unset,
    };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
